export default __webpack_public_path__ + "static/media/apps_supervisão_acesso.869bfc66.png";